import { Box, Link, Typography } from "@mui/material";
import CopyButton from "components/common/CopyButton";
import { useState } from "react";

const DETAIL_SX = { whiteSpace: "pre-line", overflowWrap: "anywhere" };

// A summary message with a "Show more" affordance that reveals its detail: a
// string, or a list of strings shown as bullets. A detail is only offered when
// the message does not already spell it out, as older responses embed it.
// Once everything is on show, a button copies it.
const ErrorSummary = ({ message, detail }) => {
  const [expanded, setExpanded] = useState(false);
  const moreDetails = (Array.isArray(detail) ? detail : [detail])
    .filter((line) => typeof line === "string")
    .map((line) => line.trim())
    .filter((line) => line !== "" && !(message ?? "").includes(line));
  const hasMoreDetail = moreDetails.length > 0;
  const isShowingDetail = hasMoreDetail && expanded;
  const isList = moreDetails.length > 1;
  const copiedDetail = isList
    ? moreDetails.map((line) => `- ${line}`).join("\n")
    : moreDetails[0];
  return (
    <>
      <Typography variant={"body2"}>{message}</Typography>
      {isShowingDetail &&
        (isList ? (
          <Box component={"ul"} sx={{ m: 2, mt: 1, pl: 2 }}>
            {moreDetails.map((line, index) => (
              <Typography
                key={index}
                component={"li"}
                variant={"body2"}
                sx={DETAIL_SX}
              >
                {line}
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant={"body2"} sx={{ m: 2, mt: 1, ...DETAIL_SX }}>
            {moreDetails[0]}
          </Typography>
        ))}
      <Box sx={{ mt: 0.5 }}>
        {hasMoreDetail && !expanded ? (
          <Link
            component={"button"}
            variant={"body2"}
            color={"inherit"}
            sx={{ display: "block", fontWeight: 500 }}
            onClick={() => setExpanded(true)}
          >
            {"Show more"}
          </Link>
        ) : (
          <CopyButton
            variant={"button"}
            label={"Copy details"}
            scale={"small"}
            content={[message, isShowingDetail ? copiedDetail : null]
              .filter(Boolean)
              .join("\n\n")}
          />
        )}
      </Box>
    </>
  );
};

export default ErrorSummary;
